Router = App.loadClass 'core::Router'

class exports.NSolverRouter extends Router

    prefix: 'NSolver'
    module_name: 'NSolverRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'grower::Angular/NSolver/NSolverService', [
            '$http'
            '$rootScope'
            '$state'
            '$stateParams'
            '$q'
            'Core.Services.Session'
        ]

        @controller 'grower::Angular/NSolver/SidebarController', [
            '$scope'
            '$transitions'
            'NSolver.Services.NSolverService'
            '$state'
            '$q'
            '$stateParams'
            '$http'
            '$timeout'
            '$uibModal'
            '$window'
        ]

        @controller 'grower::Angular/NSolver/StepsController', [
            '$scope'
            '$transitions'
            'NSolver.Services.NSolverService'
            '$state'
            '$uibModal'
            '$http'
            '$window'
            '$timeout'
        ], 'StepsController'

        for widget in [
            'FieldSelection'
            'ManagementIntensity'
            'Events'
            'TillagePractice'
            'SeasonDetails'
            'ApplicationDetails'
        ]
            @controller "grower::Angular/NSolver/Widgets/#{widget}Controller", [
                '$scope'
                '$transitions'
                '$uibModal'
                '$http'
                'NSolver.Services.NSolverService'
                '$state'
                '$q'
                '$ngModal'
            ], "#{widget}WidgetController"

        @controller 'grower::Angular/Operation/Machinery/ModalMachineryController', [
            '$scope'
            '$transitions'
            '$uibModal'
            '$uibModalInstance',
            'Operation.Services.Machinery'
            '$q'
            'viewing'
            'editing'
            'id'
            'typeId'
            'autoSelect'
        ]

    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'grower.nsolver',
                url: '/nsolver'
                templateUrl: 'backend/grower/nsolver/sidebar'
                controller: 'NSolver.Controllers.SidebarController'

            .state 'grower.nsolver.step',
                url: '/:id/step/:step'
                params:
                    id:
                        type: 'int'
                        dynamic: true
                        squash: false
                    step:
                        type: 'int'
                        value: 1
                        dynamic: true
                        squash: false
                views:
                    fullpage:
                        templateUrl: 'backend/grower/nsolver/steps'
